import { colord, extend, getFormat } from "colord";
import namesPlugin from "colord/plugins/names";

extend([namesPlugin]);

export type Format = "name" | "hex" | "rgb" | "hsl" | "hsv" | "hwb" | "xyz" | "lab" | "lch" | "cmyk";

export const convertColor = (color: string, format?: Format, onError?: (error: string) => void) => {
  if (color === "") return "";

  const colorObject = parseAndValidateColorString(color, onError);

  if (!colorObject) return undefined;

  if (format === undefined) {
    format = getFormat(color);
  }

  switch (format) {
    case "hex":
      return colorObject.toHex().toUpperCase();
    case "hsl":
      return colorObject.toHslString().toUpperCase();
    case "name":
      return colorObject.toName({ closest: true });
    default:
      return colorObject.toRgbString().toUpperCase();
  }
};

const parseAndValidateColorString = (color: string, onError?: (error: string) => void) => {
  const colorObject = colord(color);

  if (!colorObject.isValid()) {
    console.warn(`Color: "${color}" is not a valid color.`);
    onError?.(`"${color}" is not a valid color.`);
    return undefined;
  }

  return colorObject;
};
